import { READER_COLUMNS } from '@/components/ReadersTable/readersTableLayout';

const READERS_COLUMN_TITLE_MAP: Record<string, string> = Object.fromEntries(
  READER_COLUMNS.map((c) => [c.id, c.title.trim()]).filter(([, title]) => title.length > 0)
);

export function readersCatalogFilterColumnTitle(columnId: string): string {
  return READERS_COLUMN_TITLE_MAP[columnId] ?? columnId;
}
